import React from "react";

const COLOR_SLOTS = [
    { key: "primary", label: "Primary" },
    { key: "primaryForeground", label: "Primary Text" },
    { key: "secondary", label: "Secondary" },
    { key: "secondaryForeground", label: "Secondary Text" },
    { key: "accent", label: "Accent" },
    { key: "accentForeground", label: "Accent Text" },
    { key: "background", label: "Background" },
    { key: "foreground", label: "Foreground" },
    { key: "muted", label: "Muted" },
    { key: "mutedForeground", label: "Muted Text" },
    { key: "destructive", label: "Destructive" },
    { key: "destructiveForeground", label: "Destructive Text" },
    { key: "border", label: "Border" },
    { key: "ring", label: "Focus Ring" },
];

function ColorSlot({ label, value, onChange }) {
    return (
        <div className="flex items-center gap-3">
            <input
                type="color"
                value={value || "#000000"}
                onChange={(e) => onChange(e.target.value)}
                className="w-10 h-10 rounded cursor-pointer border border-input p-0.5"
            />
            <div className="flex-1">
                <label className="text-sm font-medium">{label}</label>
                <input
                    type="text"
                    value={value || ""}
                    onChange={(e) => onChange(e.target.value)}
                    placeholder="#000000"
                    className="block w-full mt-1 text-xs px-2 py-1 border border-input rounded-md bg-background"
                />
            </div>
        </div>
    );
}

export default function DesignSystemColors({ colors, onChange }) {
    const handleChange = (key, value) => {
        onChange({ ...colors, [key]: value });
    };

    return (
        <div>
            <h3 className="text-sm font-semibold mb-4">Color Palette</h3>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                {COLOR_SLOTS.map((slot) => (
                    <ColorSlot
                        key={slot.key}
                        label={slot.label}
                        value={colors?.[slot.key]}
                        onChange={(val) => handleChange(slot.key, val)}
                    />
                ))}
            </div>
        </div>
    );
}
